import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listBatches, getBatch, reprocessBatch } from '../api/client';
import type { AiModelKey } from '../utils/aiModels';

export function useBatches() {
  return useQuery({
    queryKey: ['batches'],
    queryFn: listBatches,
    staleTime: 30 * 1000, // 30 seconds
  });
}

export function useBatch(date: string, pollingEnabled?: boolean) {
  return useQuery({
    queryKey: ['batch', date],
    queryFn: () => getBatch(date),
    staleTime: pollingEnabled ? 0 : 10 * 1000,
    enabled: !!date,
    refetchInterval: pollingEnabled ? 3000 : false,
  });
}

export function useReprocessBatch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ date, aiModel }: { date: string; aiModel?: AiModelKey }) =>
      reprocessBatch(date, aiModel),
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({ queryKey: ['batch', variables.date] });
    },
  });
}
